import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=4b0fa7ed&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=ts&"
export * from "./PermissionDenied.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=4b0fa7ed&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fa7ed",
  null
  
)

export default component.exports